import "./index.css"

import { jsxs, jsx } from 'react/jsx-runtime';
import { CtaBlock } from '@design-system/cta-block';
import { ExtendableImage } from '@design-system/extendable-image';
import { HeadingBlock } from '@design-system/heading-block';
import classNames from 'classnames';
import { forwardRef } from 'react';

const AssetItem = forwardRef(({ className, headingBlock, image, align = 'start', ctaBlock, mediaVariant = 'rounded', tag: Tag = 'div', }, ref) => {
    const headingBlockProps = Object.assign(Object.assign({}, headingBlock), { align });
    return (jsxs(Tag, Object.assign({ ref: ref, className: classNames('cds-asset-item', className, {
            [`cds-asset-item--align-${align}`]: align,
        }) }, { children: [jsx("div", Object.assign({ className: "cds-asset-item__content" }, { children: jsxs("div", Object.assign({ className: "cds-asset-item__content-inner" }, { children: [jsx(HeadingBlock, Object.assign({}, headingBlockProps)), ctaBlock && jsx(CtaBlock, Object.assign({ align: align }, ctaBlock))] })) })), image && (jsx("div", Object.assign({ className: classNames('cds-asset-item__media', `cds-asset-item__media--${mediaVariant}`) }, { children: jsx(ExtendableImage, Object.assign({}, image, { className: "cds-asset-item__media-image" })) })))] })));
});

export { AssetItem };
